import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './utils/global'
import "lib-flexible/flexible"
import './assets/styles/main.css'

import Api from './api'
Vue.use(Api)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
